import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const LoadingColumn = ColumnTree.defineNode('loading', _context => ({
  title: (
    <FormattedMessage
      id="marketplace-table-heading-loadingconfig"
      description="Table heading"
      defaultMessage="Loading configuration, repeated for cell headings"
    />
  ),
}));
